import { CoverBackground } from 'components/CoverBackground'
import { AnimatePresence, motion } from 'framer-motion'
import { useStoreActions } from 'hooks/useStore'
import React, { ComponentType } from 'react'
import usePortal from 'react-cool-portal'
import { Button, Col, Container, Row } from 'reactstrap'
import styled from 'styled-components'
import { Phone } from './phone'
import { Share } from './share'
import { Whats } from './whats'

const Bar = styled(motion.div)`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  background: white;
  z-index: 1020;
  padding: 8px 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
`

const Main = styled.div`
  display: flex;
  align-items: center;
`

const Image = styled(CoverBackground)`
  width: 64px;
  height: 64px;
  border-radius: 64px;
  margin-right: 16px;
`

const Info = styled.div`
  flex: 1;
`

const Name = styled.h6`
  margin: 0;
  font-size: 16px;
`

const Tag = styled.span`
  color: #757d88;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
`

interface Props {
  agent: any
  name: string
  principalNotes: string
  isPresent: boolean
  beforeOnShareClick: () => Promise<void>
  shareUrl: string
}

export const AgentBar: ComponentType<Props> = ({ isPresent, agent, name, principalNotes, beforeOnShareClick, shareUrl }) => {
  const setInvader = useStoreActions((actions) => actions.ui.setInvader)

  const { Portal } = usePortal({
    clickOutsideToHide: false,
    escToHide: false,
    internalShowHide: false,
  })

  const onMoreInformationClick = () => {
    beforeOnShareClick()
    setInvader('lead')
  }

  return (
    <AnimatePresence>
      {isPresent && (
        <Portal>
          <Bar
            className="print--none"
            initial={{ y: 150 }}
            animate={{ y: 0 }}
            exit={{ y: 150 }}
            transition={{ ease: 'easeInOut', duration: 0.4 }}
          >
            <Container>
              <Row className="justify-content-center">
                <Col lg="10" className="d-flex">
                  <div className="d-flex align-items-center flex-grow-1">
                    <Image url={agent.avatar?.thumbnailUrl} position="top center" />
                    <Info>
                      <Name>
                        {agent.firstName} {agent.lastName}
                      </Name>
                      {agent.isCertified && <Tag className="text-certificate-orange">Asesor Certificado</Tag>}
                    </Info>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="pr-4">
                      <Phone phone1={agent.phone1} />
                    </div>
                    <div className="pr-4">
                      <Whats whatsapp={agent.whatsapp} shareUrl={shareUrl} beforeOnShareClick={beforeOnShareClick} hideLabel />
                    </div>
                    <div className="pr-4">
                      <Share subject={name} body={principalNotes} beforeOnShareClick={beforeOnShareClick} shareUrl={shareUrl} hideLabel />
                    </div>
                    <Button color="primary" onClick={() => onMoreInformationClick()}>
                      Solicitar más información
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg="10">
                  <p className="p-0 text-center text-primary fs-6 text">
                    <small>Si eres una agencia externa por favor contacta al 9999441214 para coordinar una cita</small>
                    <br />
                    <small>Trabajamos únicamente con agencias establecidas y afiliadas a AMPI</small>
                  </p>
                </Col>
              </Row>
            </Container>
          </Bar>
        </Portal>
      )}
    </AnimatePresence>
  )
}
